<template>
    <div v-loading="gitLoading">
      <h3 v-if="isBranchesLoading">Loading branches...</h3>
        <el-select v-if="!isBranchesLoading" v-model="selectedBranch" @change="branchWillChange" placeholder="Select branch" filterable>
          <el-option
                  v-for="item in available_branches"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
          </el-option>
        </el-select>
        <h3 v-if="isBranchDetailsLoading">Loading branch details...</h3>
        <div v-if="!isBranchDetailsLoading && selectedBranchDetails" class="u-mt1">
          <div>{{selectedBranchDetails.user}}</div>
          <div>{{selectedBranchDetails.message}}</div>
          <div>{{selectedBranchDetails.commit_date | moment('YYYY-MM-DD HH:mm')}} ({{selectedBranchDetails.commit_date |  moment("from", "now")}})</div>

        </div>
        <div class="u-mt2 u-text--success c-heading--bold" v-if="commitId">Commit: {{ commitId }}</div>
    </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import ElCheckbox from 'element-ui/packages/checkbox/src/checkbox'

export default {
  components: {
    ElCheckbox,
  },
  name: 'ba-new-build-component',
  data () {
    return {
      loading: false,
      commitId: '',
      selectedBranch: null,
      available_branches: [],
      selectedBranchDetails: null,
      isBranchesLoading: true,
      isBranchDetailsLoading: false,
      buildComment: '',
      gitLoading: null,
    }
  },
  beforeMount () {
    this.load_available_branches()
  },
  methods: {
    setGitLoadLoading (loading) {
      if (this.gitLoading === loading) return
      this.gitLoading = loading
      if (this.gitLoading) {
        this.$emit('gitLoading', {loading: true})
      } else {
        this.$emit('gitLoading', {loading: false, ...this.getData()})
      }
    },
    async load_available_branches () {
      this.setGitLoadLoading(true)
      this.isBranchesLoading = true
      let response = await axios.get(`${config.url}/new-build/branches/`)
      this.selectedBranch = response.data.default_branch
      this.available_branches = response.data.branches

      this.branchWillChange(this.selectedBranch)
      this.isBranchesLoading = false
    },
    async branchWillChange (e) {
      this.setGitLoadLoading(true)
      let selected = this.available_branches.find((_) => _.name === e)
      this.commitId = selected.sha
      this.buildComment = selected.name
      this.isBranchDetailsLoading = true

      let response
      try {
        response = await axios.get(selected.link)
      } finally {
        this.isBranchDetailsLoading = false
        this.setGitLoadLoading(false)
      }
      if (!response) return

      this.selectedBranchDetails = response.data
    },

    getData () {
      return {
        commitId: this.commitId,
        buildComment: this.buildComment
      }
    },
  },
}
</script>
